var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVulnKb(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "kb",
    width: 12.41,
    height: 19,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.58 12.667V9.896l.479-.36a4.418 4.418 0 0 0-2.651-7.953h-.406A4.418 4.418 0 0 0 1.81 4.605 4.41 4.41 0 0 0 3.353 9.53l.477.357v2.779h4.75Zm1.583 0c0 .874-.709 1.583-1.583 1.583H3.83a1.583 1.583 0 0 1-1.584-1.583v-1.99A5.993 5.993 0 0 1 .308 4.104 6.002 6.002 0 0 1 6.002 0h.406a6.002 6.002 0 0 1 3.755 10.684v1.983ZM3.83 16.625a.792.792 0 1 1 0-1.583h4.75a.792.792 0 1 1 0 1.583H3.83ZM4.62 19a.792.792 0 1 1 0-1.583h3.167a.792.792 0 1 1 0 1.583H4.621Z",
    fill: "#264D6D",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVulnKb);
export default __webpack_public_path__ + "static/media/vuln-kb.acf312d6b7b19b4fb70ac407c73b26db.svg";
export { ForwardRef as ReactComponent };